import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Header.css';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import NavLink from '../NavLink';
import messages from '../../locale/messages';
import Link from '../Link';
import { connect } from 'react-redux';
import cx from 'classnames';
import { logoUploadDir } from '../../config'
import { getImageUrl } from '../../helpers/getImageUrl';
import { flowRight as compose } from 'lodash';
import history from '../../history';
import HeaderModal from '../HeaderModal/HeaderModal';
import { openHeaderModal } from '../../actions/siteadmin/modalActions';
import { choseToTheme } from '../../actions/currency/getCurrencyRates';

import { formatLocale } from '../../helpers/formatLocale';
import LanguageIcon from '../../../public/Icons/languageIcon.svg';
//images
import selectedLightIcon from '../../../public/Icons/lightModeOn.svg';
import selectedDarkIcon from '../../../public/Icons/darkModeOn.svg';
import dropDownLightIcon from '../../../public/Icons/lightModeOff.svg';
import dropDownDarkIcon from '../../../public/Icons/darkModeOff.svg';


class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: 0,
    };
    this.openMenu = this.openMenu.bind(this);
    this.openClose = this.openClose.bind(this);
  }



  async openMenu() {
    this.setState({
      isOpen: 1,
    })
  }
  async openClose() {
    this.setState({
      isOpen: 0,
    })
  }

  handleChange(e) {
    const { openHeaderModal } = this.props;
    openHeaderModal('languageModal');
  }



  render() {
    let location;

    if (history.location) {
      location = history.location.pathname;
    }



    const { logo, logoHeight, logoWidth, siteName, isOpen, currentLocale, selectedTheme, choseToTheme } = this.props;
    return (
      <div className={cx(s.root, 'mainMenu')}>
        <HeaderModal />
        <Navbar expand="lg" className={cx(s.navBg, { ['homeHeader']: location === '/' || location === '/home' }, 'bgBlackTwo')}>
          <Navbar.Brand>
            <Link className={s.brand} to="/">
              <img
                src={'/images/landing/paze_logo_black.png'}
                className={s.logoImg}
                alt={siteName || 'PazeX'}
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className={cx(s.borderNone, s.outlineNone)}
            children={
              <div className={'menuToggle'} onClick={() => this.openMenu()}>
                {/* <input type="checkbox" /> */}
                <span></span>
                <span></span>
                <span></span>
                {/* &#9776; */}
              </div>
            }
          />
          <Navbar.Collapse className={cx({ [s.menuOpened]: this.state.isOpen == 1 }, s.justifyFlexEnd, s.menuClosed, 'bgBlackTwo')} in={isOpen} id="basic-navbar-nav">

            <Nav className={cx(s.navigationLink, 'navigationLinkDark', 'bgBlackTwo', 'navigationMenuFlexContainer')} onClick={() => this.openClose()}>
              <div className={cx(s.closeButton, 'closeButtonHomeRTL')}> &#x2715; </div>

              <NavLink to="/" ><FormattedMessage {...messages.homeonly} /></NavLink>
              <NavLink to="/rider" ><FormattedMessage {...messages.rider} /></NavLink>
              <NavLink to="/driver" ><FormattedMessage {...messages.driver} /></NavLink>
            </Nav>
            <Link to="/support" className={s.contactBtnStandalone}><FormattedMessage {...messages.contact} /></Link>
          </Navbar.Collapse>
        </Navbar>
      </div>
    )
  }
}

const mapState = (state) => ({
  logo: state.siteSettings.data?.homeLogo || '',
  logoHeight: state.siteSettings.data?.logoHeight || 0,
  logoWidth: state.siteSettings.data?.logoWidth || 0,
  siteName: state.siteSettings.data?.siteName || 'Admin Panel',
  currentLocale: state.intl.locale,
  selectedTheme: state.currency.theme
})
const mapDispatch = {
  openHeaderModal,
  choseToTheme
}

export default compose(
  withStyles(s),
  connect(mapState, mapDispatch)
)(Header)
